/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/pfs/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(499);


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObj = __webpack_require__(715);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Sources cannot be null or undefined');
		}
	
		return Object(val);
	}
	
	function assignKey(to, from, key) {
		var val = from[key];
	
		if (val === undefined || val === null) {
			return;
		}
	
		if (hasOwnProperty.call(to, key)) {
			if (to[key] === undefined || to[key] === null) {
				throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
			}
		}
	
		if (!hasOwnProperty.call(to, key) || !isObj(val)) {
			to[key] = val;
		} else {
			to[key] = assign(Object(to[key]), from[key]);
		}
	}
	
	function assign(to, from) {
		if (to === from) {
			return to;
		}
	
		from = Object(from);
	
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				assignKey(to, from, key);
			}
		}
	
		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(from);
	
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					assignKey(to, from, symbols[i]);
				}
			}
		}
	
		return to;
	}
	
	module.exports = function deepAssign(target) {
		target = toObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			assign(target, arguments[s]);
		}
	
		return target;
	};


/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var DYNAMIC_EVENT_DURATION_SUFFIX = exports.DYNAMIC_EVENT_DURATION_SUFFIX = '_intervalDuration';
	var DYNAMIC_EVENT_FAILED_SUFFIX = exports.DYNAMIC_EVENT_FAILED_SUFFIX = '_intervalFailed';
	var DYNAMIC_EVENT_END_SUFFIX = exports.DYNAMIC_EVENT_END_SUFFIX = '_intervalEnded';
	var DYNAMIC_EVENT_END_NAME = exports.DYNAMIC_EVENT_END_NAME = 'profileIntervalDidEnd';
	var DYNAMIC_EVENT_END_SUFFIXES_REGEX = exports.DYNAMIC_EVENT_END_SUFFIXES_REGEX = new RegExp('(' + [DYNAMIC_EVENT_DURATION_SUFFIX, DYNAMIC_EVENT_FAILED_SUFFIX, DYNAMIC_EVENT_END_SUFFIX].join('|') + ')$');
	var DYNAMIC_EVENT_BUBBLES = exports.DYNAMIC_EVENT_BUBBLES = true;
	var DYNAMIC_EVENT_CANCELABLE = exports.DYNAMIC_EVENT_CANCELABLE = true;

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Return a string with format "time name"
	 * @param {String} name
	 * @param {Number} time
	 * @returns {String}
	 */
	var formatTiming = exports.formatTiming = function formatTiming(name, time) {
	  return Math.round(time) + " " + name;
	};
	
	/**
	 * Convert an object to an array of formatTiming strings [ 'obj.value obj.key' ]
	 * @param {Object} object
	 * @returns {Array}
	 */
	var objectToTimingArray = exports.objectToTimingArray = function objectToTimingArray(o) {
	  return Object.keys(o).map(function (key) {
	    return formatTiming(key, o[key]);
	  });
	};

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formatPerformanceEntry = exports.getPerformanceEntriesByName = exports.clearPerformanceMeasure = exports.isPerformanceMeasure = exports.isPerformanceMark = undefined;
	
	var _formatTiming = __webpack_require__(417);
	
	var _window = window,
	    performance = _window.performance;
	
	var ENTRY_TYPES = {
	    MARK: 'mark',
	    MEASURE: 'measure'
	};
	
	var isPerformanceMark = exports.isPerformanceMark = function isPerformanceMark(entry) {
	    return entry.entryType === ENTRY_TYPES.MARK;
	};
	
	var isPerformanceMeasure = exports.isPerformanceMeasure = function isPerformanceMeasure(entry) {
	    return entry.entryType === ENTRY_TYPES.MEASURE;
	};
	
	/**
	 *
	 * @param {PerformanceMeasure} measure
	 */
	var clearPerformanceMeasure = exports.clearPerformanceMeasure = function clearPerformanceMeasure(measure) {
	    performance.clearMeasures(measure.name);
	};
	
	/**
	 * Get performance entries by name from Performance API
	 * @param {string} name
	 * @returns {PerformanceEntry[]}
	 */
	var getPerformanceEntriesByName = exports.getPerformanceEntriesByName = function getPerformanceEntriesByName(name) {
	    return performance.getEntriesByName(name);
	};
	
	/**
	 * Formats Performance Entry objects for beacon request
	 * @param {PerformanceEntry} entry
	 * @returns {string}
	 */
	var formatPerformanceEntry = exports.formatPerformanceEntry = function formatPerformanceEntry(entry) {
	    var name = entry.name,
	        startTime = entry.startTime,
	        duration = entry.duration;
	
	    var time = 0;
	
	    if (isPerformanceMark(entry)) {
	        time = startTime;
	    } else if (isPerformanceMeasure(entry)) {
	        time = duration;
	    }
	
	    return (0, _formatTiming.formatTiming)(name, time);
	};

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _clientProfilerCore = __webpack_require__(509);
	
	var _clientProfilerCore2 = _interopRequireDefault(_clientProfilerCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Add an event listener that fires a profile call then removes itself
	 * @param {*} globalEvent window event name
	 * @param {*} metricName name to profile. globalEvent will be used if non is provided
	 */
	var addProfileEvent = function addProfileEvent(globalEvent) {
	    var metricName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalEvent;
	    var _global = global,
	        ClientProfiler = _global.ClientProfiler,
	        addEventListener = _global.addEventListener,
	        removeEventListener = _global.removeEventListener;
	
	    var fireProfile = function fireProfile() {
	        ClientProfiler.profile(metricName);
	        removeEventListener(globalEvent, fireProfile);
	    };
	    addEventListener(globalEvent, fireProfile);
	};
	
	/**
	 * Custom sendBeacon function to override ClientProfiler's default sendBeacon so we can call the
	 * zillow-web ClientProfile endpoint. We should remove this fallback as soon as the new ZDC service
	 * is ready.
	 *
	 * @param {object} p - params provided by the ClientProfiler when sendBeacon is called
	 * @param {string} [p.beaconUrl = '/ui/ClientProfile.htm] - endpoind URL from the ClientProfiler config
	 * @param {object} p.eventNameMap - (unused) machine --> human event name map
	 * @param {object} p.eventThresholds - (unused) thresholds for each event
	 * @param {array}  p.profiles - profiled events
	 * @param {object} p.staticBeaconData - static data from the ClientProfiler config
	 */
	var sendBeaconOverride = function sendBeaconOverride(params) {
	    var beaconUrl = params.beaconUrl,
	        profiles = params.profiles,
	        _params$staticBeaconD = params.staticBeaconData,
	        hostId = _params$staticBeaconD.hostId,
	        pageName = _params$staticBeaconD.pageName,
	        requestId = _params$staticBeaconD.requestId;
	
	    var DEFAULT_BEACON_URL = '/ui/ClientProfile.htm';
	
	    var beaconRequestUrl = [(beaconUrl || DEFAULT_BEACON_URL) + '?pageName=' + pageName, 'hostId=' + hostId, 'requestId=' + requestId, 'profile=' + profiles.join()].join('&');
	
	    if (global.navigator && global.navigator.sendBeacon) {
	        global.navigator.sendBeacon(beaconRequestUrl);
	    } else {
	        var xhr = new global.XMLHttpRequest();
	        xhr.open('GET', beaconRequestUrl, false);
	        xhr.send();
	    }
	};
	
	// Initialize ClientProfiler
	global.ClientProfiler = new _clientProfilerCore2.default({
	    pageName: 'UNKNOWN',
	    sendBeaconOverride: sendBeaconOverride
	});
	
	addProfileEvent('DOMContentLoaded');
	addProfileEvent('load', 'native browser onload');
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _deepAssign = __webpack_require__(331);
	
	var _deepAssign2 = _interopRequireDefault(_deepAssign);
	
	__webpack_require__(514);
	
	var _BeaconEntryQueue = __webpack_require__(510);
	
	var _BeaconEntryQueue2 = _interopRequireDefault(_BeaconEntryQueue);
	
	var _dynamicEventHelper = __webpack_require__(512);
	
	var _initClientProfilerEvents = __webpack_require__(513);
	
	var _sendBeacon2 = __webpack_require__(515);
	
	var _performanceEntryUtils = __webpack_require__(418);
	
	var _formatTiming = __webpack_require__(417);
	
	var _BrowserTimings = __webpack_require__(511);
	
	var _setAppInfo = __webpack_require__(516);
	
	var _setAppInfo2 = _interopRequireDefault(_setAppInfo);
	
	var _package = __webpack_require__(717);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_APP_CONFIG = {
	    // app configuration
	    enableBeaconing: true,
	    pageLoadBeaconDelay: 3000,
	    sendBeaconOverride: null,
	
	    // event info
	    eventNameMap: null,
	    eventThresholds: null,
	
	    // static data to include with every beacon, e.g., page name, environment, build hash, etc.
	    staticBeaconData: {
	        pageName: 'UNKNOWN'
	    }
	};
	
	var ClientProfiler = function () {
	    function ClientProfiler(initAppConfig) {
	        var _this = this;
	
	        _classCallCheck(this, ClientProfiler);
	
	        (0, _setAppInfo2.default)(_package2.default.name, '2e504d1');
	
	        this.appConfig = (0, _deepAssign2.default)({}, DEFAULT_APP_CONFIG, initAppConfig);
	
	        this.beaconFrom = 0;
	        this.staticEntryQueue = new _BeaconEntryQueue2.default();
	        this.dynamicEntryQueue = new _BeaconEntryQueue2.default();
	        this.navigationTimings = new _BrowserTimings.NavigationTimings();
	        this.resourceTimings = new _BrowserTimings.ResourceTimings();
	
	        ['clearAllBeaconHistory', 'getPerformanceEntries', 'getProfiles', 'profile', 'profileIntervalBegin', 'profileIntervalEnd', 'profileIntervalFail', 'sendBeacon', 'sendLoadBeacon'].forEach(function (method) {
	            _this[method] = _this[method].bind(_this);
	        });
	
	        if (this.appConfig.enableBeaconing) {
	            (0, _initClientProfilerEvents.initClientProfilerEvents)(this.sendBeacon, this.sendLoadBeacon);
	        }
	    }
	
	    _createClass(ClientProfiler, [{
	        key: 'sendBeacon',
	        value: function sendBeacon() {
	            var _appConfig = this.appConfig,
	                beaconUrl = _appConfig.beaconUrl,
	                eventNameMap = _appConfig.eventNameMap,
	                eventThresholds = _appConfig.eventThresholds,
	                sendBeaconOverride = _appConfig.sendBeaconOverride,
	                staticBeaconData = _appConfig.staticBeaconData;
	
	            var profiles = this.getProfiles();
	            if (profiles.length > 0) {
	                (sendBeaconOverride || _sendBeacon2.sendBeacon)({
	                    beaconUrl: beaconUrl,
	                    eventNameMap: eventNameMap,
	                    eventThresholds: eventThresholds,
	                    profiles: profiles,
	                    staticBeaconData: staticBeaconData
	                });
	            }
	        }
	    }, {
	        key: 'sendLoadBeacon',
	        value: function sendLoadBeacon() {
	            this.profile('loaded ' + this.appConfig.staticBeaconData.pageName);
	            setTimeout(this.sendBeacon, this.appConfig.pageLoadBeaconDelay);
	            this.profile('onload completed');
	        }
	    }, {
	        key: 'profile',
	        value: function profile(eventName) {
	            var isDynamicEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            if (!isDynamicEvent && !(0, _performanceEntryUtils.getPerformanceEntriesByName)(eventName).length) {
	                this.staticEntryQueue.queueBeaconEntry(eventName);
	                window.performance.mark(eventName);
	            } else if (isDynamicEvent) {
	                this.dynamicEntryQueue.queueBeaconEntry(eventName);
	                window.performance.mark(eventName);
	            }
	        }
	    }, {
	        key: 'profileIntervalBegin',
	        value: function profileIntervalBegin(eventName) {
	            this.profile(eventName, true);
	        }
	    }, {
	        key: 'profileIntervalEnd',
	        value: function profileIntervalEnd(eventName) {
	            (0, _dynamicEventHelper.dynamicEventHelper)(eventName, true, this.dynamicEntryQueue.queueBeaconEntry);
	        }
	    }, {
	        key: 'profileIntervalFail',
	        value: function profileIntervalFail(eventName) {
	            (0, _dynamicEventHelper.dynamicEventHelper)(eventName, false, this.dynamicEntryQueue.queueBeaconEntry);
	        }
	
	        /**
	         * Retrieve all profiles corresponding PerformanceEntry
	         * @returns {PerformanceEntry[]}
	         */
	
	    }, {
	        key: 'getPerformanceEntries',
	        value: function getPerformanceEntries() {
	            // Get static profiles
	            var staticEntryNames = [].concat(this.staticEntryQueue.getBeaconEntryQueue());
	
	            // Get dynamic profiles
	            var dynamicEntryNames = [].concat(this.dynamicEntryQueue.getBeaconEntryQueue());
	
	            // Get static profile performance entries
	            var staticPerformanceEntries = staticEntryNames.reduce(function (acc, name) {
	                return [].concat(acc, (0, _performanceEntryUtils.getPerformanceEntriesByName)(name));
	            }, []);
	
	            // Get dynamic profile performance entries
	            var dynamicPerformanceEntries = dynamicEntryNames.reduce(function (acc, name) {
	                return [].concat(acc, (0, _performanceEntryUtils.getPerformanceEntriesByName)(name));
	            }, []);
	
	            var performanceEntries = [].concat(staticPerformanceEntries, dynamicPerformanceEntries);
	
	            // Clear out dynamic performance entries that are about to be reported
	            // only. The dynamic in's performance mark is needed to measure
	            // duration when it ends.
	            (0, _dynamicEventHelper.getCompletedDynamicEvents)(dynamicPerformanceEntries).forEach(_performanceEntryUtils.clearPerformanceMeasure);
	
	            return performanceEntries;
	        }
	
	        /**
	         * Clears all profiles and their corresponding PerformanceEntry objects
	         * @returns {undefined}
	         */
	
	    }, {
	        key: 'clearAllBeaconHistory',
	        value: function clearAllBeaconHistory() {
	            this.staticEntryQueue.clearBeaconEntryQueue();
	            this.dynamicEntryQueue.clearBeaconEntryQueue();
	        }
	
	        /**
	         * Get all profiled events for beacon
	         * @returns {String[]}
	         */
	
	    }, {
	        key: 'getProfiles',
	        value: function getProfiles() {
	            var entries = this.getPerformanceEntries();
	
	            // Retrieve navigationTimings and append to profiles array
	            var navigationTimings = (0, _formatTiming.objectToTimingArray)(this.navigationTimings.pop());
	            var fullyLoadedTime = (0, _formatTiming.objectToTimingArray)(this.resourceTimings.getFullyLoadedTimeOnce());
	
	            var profiles = entries.map(_performanceEntryUtils.formatPerformanceEntry).concat(navigationTimings).concat(fullyLoadedTime);
	
	            // Clear beacon entry queues for next call.
	            this.clearAllBeaconHistory();
	
	            return profiles;
	        }
	    }, {
	        key: 'appConfig',
	        set: function set(appConfig) {
	            this.internalAppConfig = (0, _deepAssign2.default)({}, this.internalAppConfig, appConfig);
	        },
	        get: function get() {
	            return this.internalAppConfig;
	        }
	    }]);
	
	    return ClientProfiler;
	}();
	
	exports.default = ClientProfiler;

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BeaconEntryQueue = function () {
	    function BeaconEntryQueue() {
	        var _this = this;
	
	        _classCallCheck(this, BeaconEntryQueue);
	
	        this.data = {};
	        ['clearBeaconEntryQueue', 'getBeaconEntryQueue', 'getEntry', 'queueBeaconEntry', 'setEntry'].forEach(function (method) {
	            _this[method] = _this[method].bind(_this);
	        });
	    }
	
	    _createClass(BeaconEntryQueue, [{
	        key: 'getEntry',
	        value: function getEntry(name) {
	            return this.data[name];
	        }
	    }, {
	        key: 'setEntry',
	        value: function setEntry(name) {
	            var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            this.data[name] = val;
	        }
	    }, {
	        key: 'getBeaconEntryQueue',
	        value: function getBeaconEntryQueue() {
	            return Object.keys(this.data);
	        }
	    }, {
	        key: 'queueBeaconEntry',
	        value: function queueBeaconEntry(names) {
	            var _this2 = this;
	
	            if (Array.isArray(names)) {
	                names.forEach(function (name) {
	                    _this2.setEntry(name);
	                });
	            } else if (names) {
	                this.setEntry(names);
	            }
	        }
	    }, {
	        key: 'clearBeaconEntryQueue',
	        value: function clearBeaconEntryQueue() {
	            this.data = {};
	        }
	    }]);
	
	    return BeaconEntryQueue;
	}();
	
	exports.default = BeaconEntryQueue;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResourceTimings = exports.NavigationTimings = exports.FULLY_LOADED_THRESHOLD = exports.EVENT_NAMES = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _deepAssign = __webpack_require__(331);
	
	var _deepAssign2 = _interopRequireDefault(_deepAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var isNumber = function isNumber(val) {
	    return typeof val === 'number';
	};
	var isObject = function isObject(val) {
	    return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
	};
	
	var EVENT_NAMES = exports.EVENT_NAMES = {
	    FULLY_LOADED: 'fullyLoaded',
	    TTFB: 'TTFB'
	};
	var FULLY_LOADED_THRESHOLD = exports.FULLY_LOADED_THRESHOLD = 2000;
	
	/**
	 * Get metrics we care about derived from the navigation performance API, e.g.,
	 * TTFB (time to first byte)
	 *
	 * Once the class is instantiated it waits for the window's onLoad event before
	 * fetching the timings. The timings can then be peeked and poped. Popping
	 * ensures that metrics are only sent once.
	 *
	 * @see https://www.w3.org/TR/navigation-timing/#sec-window.performance-attribute
	 */
	
	var NavigationTimings = exports.NavigationTimings = function () {
	    function NavigationTimings() {
	        var _this = this;
	
	        _classCallCheck(this, NavigationTimings);
	
	        this.timings = {};
	
	        this.populateNavigationTimings = this.populateNavigationTimings.bind(this);
	
	        ['populateNavigationTimings', 'pop', 'peek'].forEach(function (method) {
	            _this[method] = _this[method].bind(_this);
	        });
	
	        // get derived navigation timings on load
	        window.addEventListener('DOMContentLoaded', this.populateNavigationTimings);
	    }
	
	    _createClass(NavigationTimings, [{
	        key: 'populateNavigationTimings',
	        value: function populateNavigationTimings() {
	            this.timings = {};
	
	            if (window.performance && window.performance.timing && isObject(window.performance.timing)) {
	                var _window$performance$t = window.performance.timing,
	                    requestStart = _window$performance$t.requestStart,
	                    responseStart = _window$performance$t.responseStart;
	
	
	                if (isNumber(requestStart) && isNumber(responseStart)) {
	                    this.timings[EVENT_NAMES.TTFB] = responseStart - requestStart;
	                }
	            }
	
	            return this.timings;
	        }
	
	        /**
	         * Retrieve timings and clear
	         * @returns {Object} timings
	         */
	
	    }, {
	        key: 'pop',
	        value: function pop() {
	            var poppedTimings = (0, _deepAssign2.default)({}, this.timings);
	            this.timings = {};
	            return poppedTimings;
	        }
	
	        /**
	         * Retrieve timings but do not clear
	         * @returns {Object} timings
	         */
	
	    }, {
	        key: 'peek',
	        value: function peek() {
	            return this.timings;
	        }
	    }]);
	
	    return NavigationTimings;
	}();
	
	/**
	 * Get metrics we care about derived from the resource performance API.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API
	 */
	
	
	var ResourceTimings = exports.ResourceTimings = function () {
	    function ResourceTimings() {
	        var _this2 = this;
	
	        _classCallCheck(this, ResourceTimings);
	
	        this.fullyLoadedTimesFoundCount = 0;
	
	        ['getFullyLoadedTime', 'getFullyLoadedTimeOnce'].forEach(function (method) {
	            _this2[method] = _this2[method].bind(_this2);
	        });
	    }
	
	    /**
	     * Get the "fully loaded" time, i.e., the completion time of the first
	     * network request that is followed by at least 2 sec of network silence.
	     *
	     * If no 2-second gap is found, or if the browser doesn't support the
	     * necessary resource timing properties (*cough* *cough* IE), an empty {}
	     * will be returned.
	     *
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
	     */
	
	
	    _createClass(ResourceTimings, [{
	        key: 'getFullyLoadedTime',
	        value: function getFullyLoadedTime() {
	            var resources = window.performance.getEntriesByType('resource') || [];
	            if (resources.length <= 0) {
	                console.warn('no resource perf records available');
	                return {};
	            }
	
	            for (var i = 0; i < resources.length; i += 1) {
	                var resource = resources[i];
	
	                // undefined if out of bounds
	                var nextResource = resources[i + 1];
	                var nextStartTime = nextResource ? nextResource.startTime : window.performance.now();
	
	                if (!resource.startTime || !resource.responseEnd) {
	                    console.warn('required resource perf props not supported by browser');
	                    return {};
	                }
	
	                if (nextStartTime - resource.responseEnd >= FULLY_LOADED_THRESHOLD) {
	                    this.fullyLoadedTimesFoundCount += 1;
	                    return _defineProperty({}, EVENT_NAMES.FULLY_LOADED, resource.responseEnd);
	                }
	            }
	
	            // no gap longer than threshold found
	            return {};
	        }
	
	        /**
	         * Get the "fully loaded" time, but only once. If called after a fully-
	         * loaded time has already been returned, return {}
	         */
	
	    }, {
	        key: 'getFullyLoadedTimeOnce',
	        value: function getFullyLoadedTimeOnce() {
	            if (this.fullyLoadedTimesFoundCount < 1) {
	                return this.getFullyLoadedTime();
	            }
	            return {};
	        }
	    }]);
	
	    return ResourceTimings;
	}();

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCompletedDynamicEvents = exports.createDynamicEvent = undefined;
	exports.dynamicEventHelper = dynamicEventHelper;
	
	var _constants = __webpack_require__(416);
	
	var _performanceEntryUtils = __webpack_require__(418);
	
	/* eslint-disable no-console */
	
	var createDynamicEvent = exports.createDynamicEvent = function createDynamicEvent() {
	    return new CustomEvent(_constants.DYNAMIC_EVENT_END_NAME, {
	        bubbles: _constants.DYNAMIC_EVENT_BUBBLES,
	        cancelable: _constants.DYNAMIC_EVENT_CANCELABLE
	    });
	};
	
	/**
	 * Clear completed performance entries from Performance API
	 * @param {PerformanceEntry[]} entries
	 */
	var getCompletedDynamicEvents = exports.getCompletedDynamicEvents = function getCompletedDynamicEvents() {
	    var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var completedEntries = entries.filter(function (entry) {
	        return _constants.DYNAMIC_EVENT_END_SUFFIXES_REGEX.test(entry.name);
	    });
	    var startEntries = completedEntries.map(function (completedEntry) {
	        var name = completedEntry.name;
	
	        var startEventName = name.replace(_constants.DYNAMIC_EVENT_END_SUFFIXES_REGEX, '');
	        return (0, _performanceEntryUtils.getPerformanceEntriesByName)(startEventName)[0];
	    }).filter(function (entry) {
	        return entry !== undefined;
	    });
	    return [].concat(startEntries, completedEntries);
	};
	
	// including dynamic event start, end, failed
	function dynamicEventHelper(eventName, didEnd, callback) {
	    var _window = window,
	        dispatchEvent = _window.dispatchEvent,
	        performance = _window.performance;
	
	    var performanceEntries = [];
	    var hasBeginMark = performance.getEntriesByName(eventName, 'mark').length;
	
	    if (!hasBeginMark) {
	        return;
	    }
	
	    if (didEnd) {
	        var endEventName = '' + eventName + _constants.DYNAMIC_EVENT_END_SUFFIX;
	        var durationEventName = '' + eventName + _constants.DYNAMIC_EVENT_DURATION_SUFFIX;
	        performance.mark(endEventName);
	        performance.measure(durationEventName, eventName, endEventName);
	        performanceEntries.push(durationEventName);
	        performance.clearMarks(endEventName);
	    } else {
	        var failedEventName = '' + eventName + _constants.DYNAMIC_EVENT_FAILED_SUFFIX;
	        performanceEntries.push(failedEventName);
	        performance.mark(failedEventName);
	    }
	    window.ghghg = 'cvccvcv';
	
	    if (callback) {
	        callback(performanceEntries);
	    }
	
	    // Pass all performance entries to event
	    dispatchEvent(createDynamicEvent());
	}

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initClientProfilerEvents = undefined;
	
	var _constants = __webpack_require__(416);
	
	/**
	 * Setup client profile event listeners
	 * @param {Function} beaconCall function to send the beacon data
	 * @param {Function} loadBeaconCall function to call on load
	 * @todo make this a default export
	 */
	var initClientProfilerEvents = exports.initClientProfilerEvents = function initClientProfilerEvents(beaconCall, loadBeaconCall) {
	  var _window = window,
	      addEventListener = _window.addEventListener;
	
	  addEventListener('beforeunload', beaconCall, false);
	
	  /**
	   * We also want to beacon the data at the end of a profile
	   * interval, so we listen for this custom event that's defined
	   * in UserTiming.
	   */
	  addEventListener(_constants.DYNAMIC_EVENT_END_NAME, beaconCall);
	  addEventListener('load', loadBeaconCall);
	}; /* eslint-disable zillow/import/prefer-default-export */

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(517);
	
	__webpack_require__(841);
	
	__webpack_require__(778);

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sendBeacon = exports.generateProfileEvents = exports.formatProfileEvents = undefined;
	
	var _deepAssign3 = __webpack_require__(331);
	
	var _deepAssign4 = _interopRequireDefault(_deepAssign3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-console */
	
	/**
	 * Format profile event objects into an array of profile event strings.
	 *
	 * Example profile event object:
	 *
	 *      aaa: {
	 *          thresholds: {
	 *              delighted: '100',
	 *              satisfied: '200'
	 *          },
	 *          timestamp: '111'
	 *      }
	 *
	 * Example formatted event string:
	 *
	 *      '111 aaa,100 delighted,200 satisfied'
	 *
	 * The first timestamp/name pair will always be the profile event, followed by the event's
	 * thresholds, sorted by timestamp, ascending.
	 *
	 * @param {object} profileEvents - profile event objects
	 */
	var formatProfileEvents = exports.formatProfileEvents = function formatProfileEvents() {
	    var profileEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return Object.keys(profileEvents).map(function (profileEventName) {
	        return (
	            // the first element is always the event pair...
	            [profileEvents[profileEventName].timestamp + ' ' + profileEventName]
	
	            // followed by its threshold pairs
	            .concat(Object.keys(profileEvents[profileEventName].thresholds).map(function (thresholdName) {
	                return profileEvents[profileEventName].thresholds[thresholdName] + ' ' + thresholdName;
	            })
	
	            // sort thresholds by time to make the order deterministic
	            .sort())
	
	            // finally, join all fields with a ','
	            .join(',')
	        );
	    });
	};
	
	/**
	 * Generate profile event objects from an array of profile event strings.
	 *
	 * Example profile events string, where '111' is the timestamp, and 'a a a' is the event name:
	 *
	 *      '111 a a a'
	 *
	 * Example profile event object, where 'aaa' is the translated event name from eventNameMap, and
	 * 'thresholds' are populated from eventThresholds:
	 *
	 *      aaa: {
	 *          thresholds: {
	 *              delighted: '100',
	 *              satisfied: '200'
	 *          },
	 *          timestamp: '111'
	 *      }
	 *
	 * @param {*} profiles
	 * @param {*} eventNameMap
	 * @param {*} eventThresholds
	 */
	var generateProfileEvents = exports.generateProfileEvents = function generateProfileEvents() {
	    var profiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var eventNameMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var eventThresholds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return profiles.reduce(function (accu, profile) {
	        var splitProfile = profile.split(' ');
	        var eventTimestamp = splitProfile[0];
	        var humanEventName = splitProfile.slice(1).join(' ');
	
	        // either get the machine event name from the event name map, or replace all non-
	        // alphanumeric characters with underscore if the name not found in the event name map
	        var machineEventName = eventNameMap[humanEventName] || humanEventName.replace(/\W/g, '_');
	
	        return (0, _deepAssign4.default)({}, accu, _defineProperty({}, machineEventName, {
	            thresholds: (0, _deepAssign4.default)({}, eventThresholds[machineEventName]),
	            timestamp: eventTimestamp
	        }));
	    }, {});
	};
	
	/**
	 * Beacons the specified data to the specified endpoint.
	 *
	 * @param {*} opts
	 * @param {*} formatProfileEvents
	 * @param {*} generateProfileEvents
	 */
	var sendBeacon = exports.sendBeacon = function sendBeacon(opts) {
	    var formatProfileEventsFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatProfileEvents;
	    var generateProfileEventsFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : generateProfileEvents;
	
	    var defaultOpts = {
	        eventNameMap: {},
	        eventThresholds: {},
	        profiles: [],
	        staticBeaconData: {}
	    };
	
	    var _deepAssign2 = (0, _deepAssign4.default)({}, defaultOpts, opts),
	        beaconUrl = _deepAssign2.beaconUrl,
	        eventNameMap = _deepAssign2.eventNameMap,
	        eventThresholds = _deepAssign2.eventThresholds,
	        profiles = _deepAssign2.profiles,
	        staticBeaconData = _deepAssign2.staticBeaconData;
	
	    if (typeof beaconUrl !== 'string') {
	        console.error('the beacon URL must be a string');
	        return;
	    }
	
	    // construct the beacon data, beginning with the static data, and adding the formatted events
	    var beaconData = (0, _deepAssign4.default)({}, staticBeaconData, {
	        events: formatProfileEventsFn(generateProfileEventsFn(profiles, eventNameMap, eventThresholds))
	    });
	
	    // fire the beacon, log an error if it wasn't sucessful
	    if (!global.navigator.sendBeacon(beaconUrl, JSON.stringify(beaconData))) {
	        console.error('beacon failure! URL:', beaconUrl, 'data:', beaconData);
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (name, version) {
	    window.appInfo = window.appInfo || {};
	    try {
	        window.appInfo[name] = version;
	    } catch (e) {
	        console.warn("unable to set app info for " + name + "@" + version + ":", e);
	    }
	};

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	// Polyfill for creating CustomEvents on IE9/10/11
	
	// code pulled from:
	// https://github.com/d4tocchini/customevent-polyfill
	// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
	
	try {
	    var ce = new window.CustomEvent('test');
	    ce.preventDefault();
	    if (ce.defaultPrevented !== true) {
	        // IE has problems with .preventDefault() on custom events
	        // http://stackoverflow.com/questions/23349191
	        throw new Error('Could not prevent default');
	    }
	} catch(e) {
	  var CustomEvent = function(event, params) {
	    var evt, origPrevent;
	    params = params || {
	      bubbles: false,
	      cancelable: false,
	      detail: undefined
	    };
	
	    evt = document.createEvent("CustomEvent");
	    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	    origPrevent = evt.preventDefault;
	    evt.preventDefault = function () {
	      origPrevent.call(this);
	      try {
	        Object.defineProperty(this, 'defaultPrevented', {
	          get: function () {
	            return true;
	          }
	        });
	      } catch(e) {
	        this.defaultPrevented = true;
	      }
	    };
	    return evt;
	  };
	
	  CustomEvent.prototype = window.Event.prototype;
	  window.CustomEvent = CustomEvent; // expose definition to window
	}


/***/ }),

/***/ 715:
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (x) {
		var type = typeof x;
		return x !== null && (type === 'object' || type === 'function');
	};


/***/ }),

/***/ 717:
/***/ (function(module, exports) {

	module.exports = {"_args":[["@zillow/client-profiler-core@2.0.1","/opt/zillow/app_data/zgcompile-slave/workspace/fe-page-frame-content-master-gradle-compile"]],"_from":"@zillow/client-profiler-core@2.0.1","_id":"@zillow/client-profiler-core@2.0.1","_inBundle":false,"_integrity":"sha512-UaP3rXs9dk5xy0oE21XYjHyqgA10I8cSir9D3cVWrCpZ+S4f4XPDAjZPKtSFFEwX6EZLuFEzW6h//FNkyVtXdw==","_location":"/@zillow/client-profiler-core","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"@zillow/client-profiler-core@2.0.1","name":"@zillow/client-profiler-core","escapedName":"@zillow%2fclient-profiler-core","scope":"@zillow","rawSpec":"2.0.1","saveSpec":null,"fetchSpec":"2.0.1"},"_requiredBy":["/"],"_resolved":"http://znpm.in.zillow.net:31050/@/@zillow/client-profiler-core/_attachments/client-profiler-core-2.0.1.tgz","_spec":"2.0.1","_where":"/opt/zillow/app_data/zgcompile-slave/workspace/fe-page-frame-content-master-gradle-compile","author":{"name":"Velocity Performance"},"dependencies":{"custom-event-polyfill":"^0.3.0","deep-assign":"^2.0.0","navigator.sendbeacon":"0.0.9","usertiming":"^0.1.8"},"description":"Initialize ClientProfiler and set up eventListener","license":"ISC","main":"./dist/ClientProfiler.js","name":"@zillow/client-profiler-core","scripts":{"lint":"eslint src","prepublish":"rm -rf dist && babel src --out-dir dist --ignore '**/*.test.js'"},"version":"2.0.1"}

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

	;(function(root) {
	  'use strict';
	
	  var isSupported = (('navigator' in root) &&
	                     ('sendBeacon' in root.navigator));
	
	  var sendBeacon = function (url, data) {
	    var xhr = ('XMLHttpRequest' in window) ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
	    xhr.open('POST', url, false);
	    xhr.withCredentials = true;
	    xhr.setRequestHeader('Accept', '*/*');
	    if (typeof data === 'string') {
	      xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
	      xhr.responseType = 'text/plain';
	    } else if (({}).toString.call(data) === '[object Blob]') {
	      if (data.type) {
	        xhr.setRequestHeader('Content-Type', data.type);
	      }
	    }
	
	    try {
	      xhr.send(data);
	    } catch (error) {}
	    return true;
	  }
	
	  if (isSupported) {
	    sendBeacon = navigator.sendBeacon.bind(navigator);
	  }
	
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = sendBeacon;
	    }
	    exports.sendBeacon = sendBeacon;
	  } else if (typeof define === 'function' && define.amd) {
	    define([], function() {
	      return sendBeacon;
	    });
	  } else if (!isSupported) {
	    root.navigator.sendBeacon = sendBeacon;
	  }
	})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 779:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process) {/* eslint-env browser,amd,node */
	//
	// usertiming.js
	//
	// A polyfill for UserTiming (http://www.w3.org/TR/user-timing/)
	//
	// Copyright 2013 Nic Jansma
	// http://nicj.net
	//
	// https://github.com/nicjansma/usertiming.js
	//
	// Licensed under the MIT license
	//
	(function(window) {
	    "use strict";
	
	    // allow running in Node.js environment
	    if (typeof window === "undefined") {
	        window = {};
	    }
	
	    // prepare base perf object
	    if (typeof window.performance === "undefined") {
	        window.performance = {};
	    }
	
	    // We need to keep a global reference to the window.performance object to
	    // prevent any added properties from being garbage-collected in Safari 8.
	    // https://bugs.webkit.org/show_bug.cgi?id=137407
	    window._perfRefForUserTimingPolyfill = window.performance;
	
	    //
	    // Note what we shimmed
	    //
	    window.performance.userTimingJsNow = false;
	    window.performance.userTimingJsNowPrefixed = false;
	    window.performance.userTimingJsUserTiming = false;
	    window.performance.userTimingJsUserTimingPrefixed = false;
	    window.performance.userTimingJsPerformanceTimeline = false;
	    window.performance.userTimingJsPerformanceTimelinePrefixed = false;
	
	    // for prefixed support
	    var prefixes = [];
	    var methods = [];
	    var methodTest = null;
	    var i, j;
	
	    //
	    // window.performance.now() shim
	    //  http://www.w3.org/TR/hr-time/
	    //
	    if (typeof window.performance.now !== "function") {
	        window.performance.userTimingJsNow = true;
	
	        // copy prefixed version over if it exists
	        methods = ["webkitNow", "msNow", "mozNow"];
	
	        for (i = 0; i < methods.length; i++) {
	            if (typeof window.performance[methods[i]] === "function") {
	                window.performance.now = window.performance[methods[i]];
	
	                window.performance.userTimingJsNowPrefixed = true;
	
	                break;
	            }
	        }
	
	        //
	        // now() should be a DOMHighResTimeStamp, which is defined as being a time relative
	        // to navigationStart of the PerformanceTiming (PT) interface.  If this browser supports
	        // PT, use that as our relative start.  Otherwise, use "now" as the start and all other
	        // now() calls will be relative to our initialization.
	        //
	
	        var nowOffset = +(new Date());
	        if (window.performance.timing && window.performance.timing.navigationStart) {
	            nowOffset = window.performance.timing.navigationStart;
	        } else if (typeof process !== "undefined" && typeof process.hrtime === "function") {
	            nowOffset = process.hrtime();
	            window.performance.now = function() {
	                var time = process.hrtime(nowOffset);
	                return time[0] * 1e3 + time[1] * 1e-6;
	            }
	        }
	
	        if (typeof window.performance.now !== "function") {
	            // No browser support, fall back to Date.now
	            if (Date.now) {
	                window.performance.now = function() {
	                    return Date.now() - nowOffset;
	                };
	            } else {
	                // no Date.now support, get the time from new Date()
	                window.performance.now = function() {
	                    return +(new Date()) - nowOffset;
	                };
	            }
	        }
	    }
	
	    //
	    // PerformanceTimeline (PT) shims
	    //  http://www.w3.org/TR/performance-timeline/
	    //
	
	    /**
	     * Adds an object to our internal Performance Timeline array.
	     *
	     * Will be blank if the environment supports PT.
	     */
	    var addToPerformanceTimeline = function() {
	    };
	
	    /**
	     * Clears the specified entry types from our timeline array.
	     *
	     * Will be blank if the environment supports PT.
	     */
	    var clearEntriesFromPerformanceTimeline = function() {
	    };
	
	    // performance timeline array
	    var performanceTimeline = [];
	
	    // whether or not the timeline will require sort on getEntries()
	    var performanceTimelineRequiresSort = false;
	
	    // whether or not ResourceTiming is natively supported but UserTiming is
	    // not (eg Firefox 35)
	    var hasNativeGetEntriesButNotUserTiming = false;
	
	    //
	    // If getEntries() and mark() aren't defined, we'll assume
	    // we have to shim at least some PT functions.
	    //
	    if (typeof window.performance.getEntries !== "function" ||
	        typeof window.performance.mark !== "function") {
	
	        if (typeof window.performance.getEntries === "function" &&
	            typeof window.performance.mark !== "function") {
	            hasNativeGetEntriesButNotUserTiming = true;
	        }
	
	        window.performance.userTimingJsPerformanceTimeline = true;
	
	        // copy prefixed version over if it exists
	        prefixes = ["webkit", "moz"];
	        methods = ["getEntries", "getEntriesByName", "getEntriesByType"];
	
	        for (i = 0; i < methods.length; i++) {
	            for (j = 0; j < prefixes.length; j++) {
	                // prefixed method will likely have an upper-case first letter
	                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);
	
	                if (typeof window.performance[methodTest] === "function") {
	                    window.performance[methods[i]] = window.performance[methodTest];
	
	                    window.performance.userTimingJsPerformanceTimelinePrefixed = true;
	                }
	            }
	        }
	
	        /**
	         * Adds an object to our internal Performance Timeline array.
	         *
	         * @param {Object} obj PerformanceEntry
	         */
	        addToPerformanceTimeline = function(obj) {
	            performanceTimeline.push(obj);
	
	            //
	            // If we insert a measure, its startTime may be out of order
	            // from the rest of the entries because the use can use any
	            // mark as the start time.  If so, note we have to sort it before
	            // returning getEntries();
	            //
	            if (obj.entryType === "measure") {
	                performanceTimelineRequiresSort = true;
	            }
	        };
	
	        /**
	         * Ensures our PT array is in the correct sorted order (by startTime)
	         */
	        var ensurePerformanceTimelineOrder = function() {
	            if (!performanceTimelineRequiresSort) {
	                return;
	            }
	
	            //
	            // Measures, which may be in this list, may enter the list in
	            // an unsorted order. For example:
	            //
	            //  1. measure("a")
	            //  2. mark("start_mark")
	            //  3. measure("b", "start_mark")
	            //  4. measure("c")
	            //  5. getEntries()
	            //
	            // When calling #5, we should return [a,c,b] because technically the start time
	            // of c is "0" (navigationStart), which will occur before b's start time due to the mark.
	            //
	            performanceTimeline.sort(function(a, b) {
	                return a.startTime - b.startTime;
	            });
	
	            performanceTimelineRequiresSort = false;
	        };
	
	        /**
	         * Clears the specified entry types from our timeline array.
	         *
	         * @param {string} entryType Entry type (eg "mark" or "measure")
	         * @param {string} [name] Entry name (optional)
	         */
	        clearEntriesFromPerformanceTimeline = function(entryType, name) {
	            // clear all entries from the perf timeline
	            i = 0;
	            while (i < performanceTimeline.length) {
	                if (performanceTimeline[i].entryType !== entryType) {
	                    // unmatched entry type
	                    i++;
	                    continue;
	                }
	
	                if (typeof name !== "undefined" && performanceTimeline[i].name !== name) {
	                    // unmatched name
	                    i++;
	                    continue;
	                }
	
	                // this entry matches our criteria, remove just it
	                performanceTimeline.splice(i, 1);
	            }
	        };
	
	        if (typeof window.performance.getEntries !== "function" || hasNativeGetEntriesButNotUserTiming) {
	            var origGetEntries = window.performance.getEntries;
	
	            /**
	             * Gets all entries from the Performance Timeline.
	             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentries
	             *
	             * NOTE: This will only ever return marks and measures.
	             *
	             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
	             */
	            window.performance.getEntries = function() {
	                ensurePerformanceTimelineOrder();
	
	                // get a copy of all of our entries
	                var entries = performanceTimeline.slice(0);
	
	                // if there was a native version of getEntries, add that
	                if (hasNativeGetEntriesButNotUserTiming && origGetEntries) {
	                    // merge in native
	                    Array.prototype.push.apply(entries, origGetEntries.call(window.performance));
	
	                    // sort by startTime
	                    entries.sort(function(a, b) {
	                        return a.startTime - b.startTime;
	                    });
	                }
	
	                return entries;
	            };
	        }
	
	        if (typeof window.performance.getEntriesByType !== "function" || hasNativeGetEntriesButNotUserTiming) {
	            var origGetEntriesByType = window.performance.getEntriesByType;
	
	            /**
	             * Gets all entries from the Performance Timeline of the specified type.
	             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbytype
	             *
	             * NOTE: This will only work for marks and measures.
	             *
	             * @param {string} entryType Entry type (eg "mark" or "measure")
	             *
	             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
	             */
	            window.performance.getEntriesByType = function(entryType) {
	                // we only support marks/measures
	                if (typeof entryType === "undefined" ||
	                    (entryType !== "mark" && entryType !== "measure")) {
	
	                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByType) {
	                        // native version exists, forward
	                        return origGetEntriesByType.call(window.performance, entryType);
	                    }
	
	                    return [];
	                }
	
	                // see note in ensurePerformanceTimelineOrder() on why this is required
	                if (entryType === "measure") {
	                    ensurePerformanceTimelineOrder();
	                }
	
	                // find all entries of entryType
	                var entries = [];
	                for (i = 0; i < performanceTimeline.length; i++) {
	                    if (performanceTimeline[i].entryType === entryType) {
	                        entries.push(performanceTimeline[i]);
	                    }
	                }
	
	                return entries;
	            };
	        }
	
	        if (typeof window.performance.getEntriesByName !== "function" || hasNativeGetEntriesButNotUserTiming) {
	            var origGetEntriesByName = window.performance.getEntriesByName;
	
	            /**
	             * Gets all entries from the Performance Timeline of the specified
	             * name, and optionally, type.
	             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbyname
	             *
	             * NOTE: This will only work for marks and measures.
	             *
	             * @param {string} name Entry name
	             * @param {string} [entryType] Entry type (eg "mark" or "measure")
	             *
	             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
	             */
	            window.performance.getEntriesByName = function(name, entryType) {
	                if (entryType && entryType !== "mark" && entryType !== "measure") {
	                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
	                        // native version exists, forward
	                        return origGetEntriesByName.call(window.performance, name, entryType);
	                    }
	
	                    return [];
	                }
	
	                // see note in ensurePerformanceTimelineOrder() on why this is required
	                if (typeof entryType !== "undefined" && entryType === "measure") {
	                    ensurePerformanceTimelineOrder();
	                }
	
	                // find all entries of the name and (optionally) type
	                var entries = [];
	                for (i = 0; i < performanceTimeline.length; i++) {
	                    if (typeof entryType !== "undefined" &&
	                        performanceTimeline[i].entryType !== entryType) {
	                        continue;
	                    }
	
	                    if (performanceTimeline[i].name === name) {
	                        entries.push(performanceTimeline[i]);
	                    }
	                }
	
	                if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
	                    // merge in native
	                    Array.prototype.push.apply(entries, origGetEntriesByName.call(window.performance, name, entryType));
	
	                    // sort by startTime
	                    entries.sort(function(a, b) {
	                        return a.startTime - b.startTime;
	                    });
	                }
	
	                return entries;
	            };
	        }
	    }
	
	    //
	    // UserTiming support
	    //
	    if (typeof window.performance.mark !== "function") {
	        window.performance.userTimingJsUserTiming = true;
	
	        // copy prefixed version over if it exists
	        prefixes = ["webkit", "moz", "ms"];
	        methods = ["mark", "measure", "clearMarks", "clearMeasures"];
	
	        for (i = 0; i < methods.length; i++) {
	            for (j = 0; j < prefixes.length; j++) {
	                // prefixed method will likely have an upper-case first letter
	                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);
	
	                if (typeof window.performance[methodTest] === "function") {
	                    window.performance[methods[i]] = window.performance[methodTest];
	
	                    window.performance.userTimingJsUserTimingPrefixed = true;
	                }
	            }
	        }
	
	        // only used for measure(), to quickly see the latest timestamp of a mark
	        var marks = {};
	
	        if (typeof window.performance.mark !== "function") {
	            /**
	             * UserTiming mark
	             * http://www.w3.org/TR/user-timing/#dom-performance-mark
	             *
	             * @param {string} markName Mark name
	             */
	            window.performance.mark = function(markName) {
	                var now = window.performance.now();
	
	                // mark name is required
	                if (typeof markName === "undefined") {
	                    throw new SyntaxError("Mark name must be specified");
	                }
	
	                // mark name can't be a NT timestamp
	                if (window.performance.timing && markName in window.performance.timing) {
	                    throw new SyntaxError("Mark name is not allowed");
	                }
	
	                if (!marks[markName]) {
	                    marks[markName] = [];
	                }
	
	                marks[markName].push(now);
	
	                // add to perf timeline as well
	                addToPerformanceTimeline({
	                    entryType: "mark",
	                    name: markName,
	                    startTime: now,
	                    duration: 0
	                });
	            };
	        }
	
	        if (typeof window.performance.clearMarks !== "function") {
	            /**
	             * UserTiming clear marks
	             * http://www.w3.org/TR/user-timing/#dom-performance-clearmarks
	             *
	             * @param {string} markName Mark name
	             */
	            window.performance.clearMarks = function(markName) {
	                if (!markName) {
	                    // clear all marks
	                    marks = {};
	                } else {
	                    marks[markName] = [];
	                }
	
	                clearEntriesFromPerformanceTimeline("mark", markName);
	            };
	        }
	
	        if (typeof window.performance.measure !== "function") {
	            /**
	             * UserTiming measure
	             * http://www.w3.org/TR/user-timing/#dom-performance-measure
	             *
	             * @param {string} measureName Measure name
	             * @param {string} [startMark] Start mark name
	             * @param {string} [endMark] End mark name
	             */
	            window.performance.measure = function(measureName, startMark, endMark) {
	                var now = window.performance.now();
	
	                if (typeof measureName === "undefined") {
	                    throw new SyntaxError("Measure must be specified");
	                }
	
	                // if there isn't a startMark, we measure from navigationStart to now
	                if (!startMark) {
	                    // add to perf timeline as well
	                    addToPerformanceTimeline({
	                        entryType: "measure",
	                        name: measureName,
	                        startTime: 0,
	                        duration: now
	                    });
	
	                    return;
	                }
	
	                //
	                // If there is a startMark, check for it first in the NavigationTiming interface,
	                // then check our own marks.
	                //
	                var startMarkTime = 0;
	                if (window.performance.timing && startMark in window.performance.timing) {
	                    // mark cannot have a timing of 0
	                    if (startMark !== "navigationStart" && window.performance.timing[startMark] === 0) {
	                        throw new Error(startMark + " has a timing of 0");
	                    }
	
	                    // time is the offset of this mark to navigationStart's time
	                    startMarkTime = window.performance.timing[startMark] - window.performance.timing.navigationStart;
	                } else if (startMark in marks) {
	                    startMarkTime = marks[startMark][marks[startMark].length - 1];
	                } else {
	                    throw new Error(startMark + " mark not found");
	                }
	
	                //
	                // If there is a endMark, check for it first in the NavigationTiming interface,
	                // then check our own marks.
	                //
	                var endMarkTime = now;
	
	                if (endMark) {
	                    endMarkTime = 0;
	
	                    if (window.performance.timing && endMark in window.performance.timing) {
	                        // mark cannot have a timing of 0
	                        if (endMark !== "navigationStart" && window.performance.timing[endMark] === 0) {
	                            throw new Error(endMark + " has a timing of 0");
	                        }
	
	                        // time is the offset of this mark to navigationStart's time
	                        endMarkTime = window.performance.timing[endMark] - window.performance.timing.navigationStart;
	                    } else if (endMark in marks) {
	                        endMarkTime = marks[endMark][marks[endMark].length - 1];
	                    } else {
	                        throw new Error(endMark + " mark not found");
	                    }
	                }
	
	                // add to our measure array
	                var duration = endMarkTime - startMarkTime;
	
	                // add to perf timeline as well
	                addToPerformanceTimeline({
	                    entryType: "measure",
	                    name: measureName,
	                    startTime: startMarkTime,
	                    duration: duration
	                });
	            };
	        }
	
	        if (typeof window.performance.clearMeasures !== "function") {
	            /**
	             * UserTiming clear measures
	             * http://www.w3.org/TR/user-timing/#dom-performance-clearmeasures
	             *
	             * @param {string} measureName Measure name
	             */
	            window.performance.clearMeasures = function(measureName) {
	                clearEntriesFromPerformanceTimeline("measure", measureName);
	            };
	        }
	    }
	
	    //
	    // Export UserTiming to the appropriate location.
	    //
	    // When included directly via a script tag in the browser, we're good as we've been
	    // updating the window.performance object.
	    //
	    if (true) {
	        //
	        // AMD / RequireJS
	        //
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return window.performance;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
	        //
	        // Node.js
	        //
	        module.exports = window.performance;
	    }
	}(typeof window !== "undefined" ? window : undefined));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(779)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// clientProfiler-8b21f5a825bb4c2f97b6.js